@let isFilterDrawerVisible = isFilterDrawerVisible$ | async;
<div
  [ngClass]="
    isFilterDrawerVisible ? 'header-width-filter' : 'header-width-full'
  "
>
  <wilson-timeline-page-frame>
    <ng-container headerContent>
      @defer (on timer(100)) {
        <wilson-shift-timeline-header
          [isFilterDrawerVisible]="isFilterDrawerVisible || false"
          class="w-100 mb-2"
        ></wilson-shift-timeline-header>
      }
    </ng-container>

    <div class="d-flex flex-column flex-grow-1 position-relative" mainContent>
      @defer (on idle) {
        <wilson-deferred-assignment-shift-card></wilson-deferred-assignment-shift-card>
        <wilson-deferred-absence-cell-view-card></wilson-deferred-absence-cell-view-card>
        <wilson-deferred-absence-timeline-view-card></wilson-deferred-absence-timeline-view-card>
        <wilson-deferred-assignment-shift-card-cell-view></wilson-deferred-assignment-shift-card-cell-view>
        <wilson-deferred-unassigned-shift-card-cell-view></wilson-deferred-unassigned-shift-card-cell-view>
        <wilson-shift-timeline-gantt-chart></wilson-shift-timeline-gantt-chart>
        <wilson-deferred-cluster-card></wilson-deferred-cluster-card>
        <wilson-deferred-stay-card></wilson-deferred-stay-card>
        <wilson-deferred-shift-icons></wilson-deferred-shift-icons>
      }
    </div>
  </wilson-timeline-page-frame>
</div>
@defer (on timer(500)) {
  <wilson-timeline-filter></wilson-timeline-filter>
} @placeholder {
  <div></div>
}
